export const env = {
  uid: "0", // 用户 uid, 用于日志上下文或登录校验
};

/** 地图数据包中声明的游戏唯一标识 */
export const GAME_ID = "6111";

/** 游戏工具 id，用于数据中台上报，各项目按自身 manifest.json 中的 toolId 填写 */
export const TOOL_ID = "gfds5pzl";

/** 游戏工具类型，用于数据中台上报，见 GameToolInfo.toolType (map=3, wiki=1) */
export const TOOL_TYPE = 3;
